import { render } from "./MinhaContaView.vue?vue&type=template&id=275a948e&scoped=true"
import script from "./MinhaContaView.vue?vue&type=script&lang=js"
export * from "./MinhaContaView.vue?vue&type=script&lang=js"

import "./MinhaContaView.vue?vue&type=style&index=0&id=275a948e&scoped=true&lang=css"

import exportComponent from "/var/www/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275a948e"]])

export default __exports__